<template>
  <v-card
  flat
  class="mx-auto"
  light
  max-width="600px"
  >
    <v-card-title>
      Generate Pre-Paid Shipping Label
    </v-card-title>
    <v-card-text v-if="request_sent">
      <p>Our staff have received your request.</p>
      <p>We will send an email with your pre-paid shipping label shortly.</p>
      <p>Thank you for visiting Capital Golf Exchange.</p>
    </v-card-text>
    <v-card-text v-else>
      Please enter your name and address below, and we'll email you a pre-paid shipping label for your trade-ins.
    
    <form>
      <v-text-field
        v-model="name"
        :error-messages="nameErrors"
        :counter="100"
        label="Name"
        required
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="address1"
        :error-messages="address1Errors"
        :counter="100"
        label="Address Line 1"
        required
        @input="$v.address1.$touch()"
        @blur="$v.address1.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="address2"
        :error-messages="address2Errors"
        :counter="100"
        label="Address Line 2 (Optional)"
        required
        @input="$v.address2.$touch()"
        @blur="$v.address2.$touch()"
      ></v-text-field> 
      <v-row>
      <v-col cols=5>
        <v-text-field
          v-model="city"
          :error-messages="address2Errors"
          label="City"
          required
          @input="$v.address2.$touch()"
          @blur="$v.address2.$touch()"
        ></v-text-field>
      </v-col>
      <v-col cols=3>
        <v-text-field
          v-model="province"
          :error-messages="address2Errors"
          label="Province"
          required
          @input="$v.address2.$touch()"
          @blur="$v.address2.$touch()"
        ></v-text-field>
      </v-col>
      <v-col cols=4>
        <v-text-field
          v-model="postal_code"
          :error-messages="address2Errors"
          label="Postal Code"
          required
          @input="$v.address2.$touch()"
          @blur="$v.address2.$touch()"
        ></v-text-field>
      </v-col>
      </v-row>
    </form>
    </v-card-text>
    <v-card-actions v-if="request_sent" class="justify-center">
      <v-btn
        large
        class="white--text"
        color="grey darken-2"
        @click="close"
      >
        Close
      </v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-btn
        large
        class="white--text"
        color="grey darken-2"
        @click="close"
      >
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        large
        class="white--text"
        color="green"
        @click="sendRequest"
        :disabled="$v.$invalid"
      >
        Get Shipping Label
      </v-btn>
    </v-card-actions>
    <!-- </div> -->
  </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'
  export default {
    name: "AddressCard",
    props: {
      request_sent: Boolean
    },
    mixins: [validationMixin],
    validations: {
      name: {required, maxLength: maxLength(100)},
      address1: {required, maxLength: maxLength(100)},
      address2: {maxLength: maxLength(100)},
      city: {required},
      province: {required},
      postal_code: {required},
    },
    data () {
      return {
        name: "",
        address1: "",
        address2: "",
        city: "",
        province: "",
        postal_code: "",
      };
    },
    created () {
      this.name = this.$store.getters.getCustomer.name;
      this.address1 = this.$store.getters.getAddress.address1;
      this.address2 = this.$store.getters.getAddress.address2;
      this.city= this.$store.getters.getAddress.city;
      this.province = this.$store.getters.getAddress.province;
      this.postal_code = this.$store.getters.getAddress.postal_code;
    },
    methods: {
      sendRequest() {
        const customer = this.$store.getters.getCustomer;
        this.$store.commit('set_customer', {...customer, name: this.name} );
        this.$store.commit('set_address', this.address);
        this.$emit('get-label');
        //this.request_sent = true;
      },
      close() {
        this.$emit('close')
      }
    },
    computed: {
      address () {
        return {
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        province: this.province,
        postal_code: this.postal_code,
        }
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push('Name must be at most 100 characters long')
        !this.$v.name.required && errors.push('Name is required.')
        return errors
      },
      address1Errors () {
        const errors = []
        if (!this.$v.address1.$dirty) return errors
        !this.$v.address1.maxLength && errors.push('Address line must be at most 100 characters long')
        !this.$v.address1.required && errors.push('Address line is required.')
        return errors
      },
      address2Errors () {
        const errors = []
        if (!this.$v.address2.$dirty) return errors
        !this.$v.address2.maxLength && errors.push('Address line must be at most 100 characters long')
        return errors
      },
      cityErrors () {
        const errors = []
        if (!this.$v.city.$dirty) return errors
        !this.$v.city.required && errors.push('City is required.')
        return errors
      },
      provinceErrors () {
        const errors = []
        if (!this.$v.province.$dirty) return errors
        !this.$v.province.required && errors.push('Province is required.')
        return errors
      },
      postalCodeErrors () {
        const errors = []
        if (!this.$v.postal_code.$dirty) return errors
        !this.$v.postal_code.required && errors.push('Postal Code is required.')
        return errors
      },
    }
  }
</script>

<style scoped>

.address-form {
  padding: 20px;
}
  
</style>
